import { useLanguage } from './useLanguage'

export function useIsUS() {
  const language = useLanguage()
  return language === 'en-US'
}
